<template>
	<div class="container">
		<headerBox></headerBox>
		<bannerBox ref="bannerChild"></bannerBox>
		<div class="content_box">
			<div class="common_search_box">
				<Input v-model="params.dwmc" @on-enter="getVip" placeholder="请输入工作单位搜索">
				</Input>
				<div class="btn_box">
					<div @click="getVip">搜索</div>
					<div @click="toReset">重置</div>
				</div>
			</div>
			<div class="title">{{typeName}}</div>
			<div class="cell">
				<img src="../../assets/images/vip1.png" />
				<div class="cell_list th">
					<div>序号</div>
					<div>工作单位</div>
					<div>会员类型</div>
				</div>
			</div>
			<div class="cell" v-for="(it,i) in vipList" :key="i">
				<img src="../../assets/images/vip2.png" />
				<div class="cell_list">
					<div>{{params.pageSize*params.pageNo-params.pageSize+i+1}}</div>
					<div>{{it.dwmc}}</div>
					<div>{{typeName}}</div>
				</div>
			</div>
			<div class="common_page_box">
				<Page @on-change="changePage" :total="total" :current="params.pageNo" :page-size="params.pageSize" show-total></Page>
			</div>
		</div>
		<footerBox></footerBox>
		<Back-top :height="100" :bottom="200">
			<div class="iconfont icon-shangjiantou"></div>
		</Back-top>
	</div>
</template>

<script>
	import bannerBox from '@/components/banner.vue'
	import headerBox from '@/components/header.vue'
	import footerBox from '@/components/footer.vue'
	import {
		getDetatilArticle
	} from '@/api/home/index'
	import {
		getVip
	} from '@/api/home/index'
	export default {
		name: 'home',
		components: {
			bannerBox,
			headerBox,
			footerBox,
		},
		data() {
			return {
				newInfo: {},
				total: 0,
				params: {
					pageNo: 1,
					pageSize: 20,
					dwmc:''
				},
				catid: '',
				vipList: [],
				typeName: '',
				tabList: [{
						name: '会长单位',
						type: 2
					},
					// {
					// 	name: '副会长单位',
					// 	type:2
					// },
					{
						name: '监事单位',
						type: 3
					},
					{
						name: '常务理事单位',
						type: 4
					},
					{
						name: '理事单位',
						type: 6
					},
					{
						name: '会员单位',
						type: 7
					}
				],
			}

		},
		mounted() {
			this.typeName = this.tabList.find(v=>v.type==this.$route.query.type).name;
			this.$refs["bannerChild"].locationList=['首页','会员名录',this.typeName];
			this.getVip()
		},
		methods: {
			/* ====================数据请求部分========================== */
			getVip() {
				getVip({
					type: this.$route.query.type,
					...this.params
				}).then(res => {
					if (res.code == 200 || res.code == 0) {
						this.vipList = res.result.records;
						this.total = res.result.total;
					}
				})
			},
			/* ====================页面交互部分========================== */
			changePage(e) {
				this.params.pageNo = e;
				this.getVip()
			},
			goDetail(it) {
				this.$router.push({
					name: '/news_detail'
				})
			},
			toReset(){
				this.params.dwmc = '';
				this.getVip()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.content_box {
		margin: 80px 200px;

		.cell {
			position: relative;

			img {
				width: 100%;
				margin: 0;
				padding: 0;
				vertical-align: top;
				// position: absolute;
			}
		
			.cell_list {
				position: absolute;
				bottom: 0;
				z-index: 99;
				height: 100%;
				width: 100%;
				display: flex;
				align-items: center;
				text-align: center;
				font-size: 14px;

				>div:first-child {
					width: 20%;
				}

				>div:nth-child(2) {
					width: 57%;
				}

				>div:last-child {
					width: 28%;
				}
			}
			
			.th{
				font-size: 15px;
			}
		}

		.page_box {
			padding-top: 40px;
			text-align: center;
		}
	}
	.title {
		font-size: 25px;
		text-align: center;
		margin-bottom: 50px;
		margin-top: 20px;
	}
</style>
